import { useCallback, useEffect, useRef, useState } from 'react';
// import { useSharedValue, withTiming } from 'react-native-reanimated';
import { IAdaptiveActionCard } from '@ninjacart/nc-nk-core';
import { useQueuedEventStore,addEventParam } from '@ninjacart/nc-events-sdk-v2';
import { getKisaanBaseURL, KissanEventType, toolId, useAppPersistenceStore } from '@ninjacart/nc-nk-store';
import { getVersion } from 'react-native-device-info';

// const VIDEO_EXPAND_HEIGHT = 240;
const VIDEO_DEFAULT_HEIGHT = 240;

export const useVideoPlayer = (
  item: IAdaptiveActionCard,
  index: number,
  isVideoFeedActive: boolean,
  onAutoPlayExpand?: (isExpanded: boolean, index: number, videoId: string | number) => void,
) => {
  const [isExpanded, setIsExpanded] = useState(false);
  // const animatedContainerHeight = useSharedValue(VIDEO_DEFAULT_HEIGHT);
  // const animatedAdMarginTop = useSharedValue(0);
  // const animatedVideoHeight = useSharedValue(VIDEO_DEFAULT_HEIGHT);
  // const scale = useSharedValue(1);
  const isAutoplayExpandRef = useRef(false);
  const lastItemId = useRef(item?.actionData?.content?.id);
  const currentInfoRef = useRef({ currentTime: 0 });
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  const uniqueDeviceId = useAppPersistenceStore((state) => state.deviceId);
  const adId = useAppPersistenceStore?.getState()?.adId;
  const isAdTrackingLimited = useAppPersistenceStore.getState().isAdTrackingLimited;
  const appVersion = getVersion();

  const hasMorethan30Secs = (item?.actionData?.content?.duration ?? 0) > 30;
  // const size = `${animatedVideoHeight.value}x300`;
  const adTagUrl = hasMorethan30Secs
    ? `${getKisaanBaseURL()}/ups/v1/tools/${toolId()}/devices/${uniqueDeviceId}/vast-ads?placement=nkvideoplayerpage&deviceAdId=${adId}&deviceIsLat=${isAdTrackingLimited}&size=${0}&source_video_id=${item?.actionData?.content?.id ?? ''}&source_video_length=${item?.actionData?.content?.duration ?? 0}&last_ad_played_at=1724751118&appVersion=${appVersion}&delay_in_secs=30`
    : undefined;

  const resetVideoState = useCallback(() => {
    console.log('🚀 ~ resetVideoState');
    // animatedVideoHeight.value = VIDEO_DEFAULT_HEIGHT;
    // scale.value = 1;
    setIsExpanded(false);
    isAutoplayExpandRef.current = false;
  }, []);

  useEffect(() => {
    if (item?.actionData?.content?.id !== lastItemId.current) {
      lastItemId.current = item?.actionData?.content?.id;
      resetVideoState();
    }
  }, [item?.actionData?.content?.id, resetVideoState]);

  useEffect(() => {
    const prevIsExpanded = isAutoplayExpandRef.current;
    // console.log('🚀 ~ isExpanded:', isExpanded, isAutoplayExpandRef.current, index);
    if (isExpanded && !prevIsExpanded) {
      isAutoplayExpandRef.current = true;
      // console.log("🚀 ~ useEffect ~ isAutoplayExpandRef:", isAutoplayExpandRef)
      // animatedVideoHeight.value = withTiming(VIDEO_EXPAND_HEIGHT, { duration: 300 });
      // scale.value = withTiming(1, { duration: 300 });
      onAutoPlayExpand?.(isExpanded, index, item?.actionData?.content?.id);
    }
    if (!isExpanded && prevIsExpanded) {
      console.log('Previous item mayb expanded!!!');
      isAutoplayExpandRef.current = false;
      // animatedVideoHeight.value = withTiming(VIDEO_DEFAULT_HEIGHT, { duration: 300 });
      // scale.value = withTiming(1, { duration: 300 });
      const autoPlayVideoShorternEvent = {
        name: KissanEventType.AUTOPLAY_VIDEO_SHORTEN,
        screenDetails: { screen: 'feed page' },
        eventParams: [
          addEventParam('videoId', item.actionData?.content?.id),
          addEventParam('videoDuration', item.actionData?.content?.itemIndex),
        ],
      };
      enqueue(autoPlayVideoShorternEvent);
    }
  }, [isVideoFeedActive, isExpanded, index, item, onAutoPlayExpand, enqueue]);

  return {
    isExpanded,
    setIsExpanded,
    // animatedVideoHeight,
    // animatedContainerHeight,
    // animatedAdMarginTop,
    // scale,
    currentInfoRef,
    adTagUrl,
    resetVideoState,
  };
};